import React, { useState, useEffect } from "react";
import { useSpring, animated } from "react-spring";

// Utility to generate random positions and delays
const getRandom = (min, max) => Math.random() * (max - min) + min;

// Gift component
const Gift = ({ src }) => {
  const [resetAnimation, setResetAnimation] = useState(false);

  // Spring animation for falling motion with random delay and position
  const styles = useSpring({
    from: { top: "-10%", left: `${getRandom(0, 90)}%` },
    to: { top: "110%" },
    reset: true,
    reverse: resetAnimation,
    onRest: () => setResetAnimation(!resetAnimation), // Loop animation
    config: { duration: getRandom(8000, 15000) }, // Randomize speed (8-15 seconds)
    delay: getRandom(0, 5000), // Random delay (0-5 seconds)
  });

  return (
    <animated.img
      src={src}
      alt="gift"
      style={{
        position: "absolute",
        width: "25px",
        height: "25px",
        ...styles,
      }}
    />
  );
};

// Main ChristmasEffect component
const ChristmasEffect = () => {
  const [gifts, setGifts] = useState([]);

  useEffect(() => {
    // Add multiple gift images
    const giftImages = [
      "/images/noel/hoa_dao.png",
      // "/images/noel/snowflake1.png",
      // "/images/noel/snowflake2.png",
      "/images/noel/chung.png",
      // "/images/noel/snowflake4.png",
      // Add paths to your gift images
    ];
    setGifts(
      Array.from({ length: 10 }).map(() => ({
        id: Math.random(),
        src: giftImages[Math.floor(Math.random() * giftImages.length)],
      })),
    );
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        overflow: "hidden",
        zIndex: -1,
      }}
    >
      {gifts.map((gift) => (
        <Gift key={gift.id} src={gift.src} />
      ))}
    </div>
  );
};

export default ChristmasEffect;
